interface Props {
  percent: number;
  title?: string;
  caption?: string;
}

// 10×10 grid of 100 squares — shade `percent` squares to make "per hundred"
// visceral. Used for sections 5.5 and 5.6.
export default function PercentGridViz({ percent, title = 'Percent grid', caption }: Props) {
  const filled = Math.max(0, Math.min(100, Math.round(percent)));
  const cells = Array.from({ length: 100 }, (_, i) => i < filled);

  return (
    <div className="card p-5 space-y-3">
      <h3 className="font-display text-lg">
        {title}{' '}
        <span className="text-ink/50 text-sm font-body font-normal math-display">
          {filled}%
        </span>
      </h3>
      <div className="flex justify-center">
        <div
          className="grid gap-[2px] p-1 bg-ink/5 rounded-lg"
          style={{ gridTemplateColumns: 'repeat(10, 20px)' }}
        >
          {cells.map((isOn, i) => (
            <div
              key={i}
              className={`w-5 h-5 rounded-sm ${isOn ? 'bg-coral' : 'bg-white'}`}
              aria-hidden="true"
            />
          ))}
        </div>
      </div>
      <div className="text-center text-sm text-ink/70 math-display">
        {filled} out of 100 squares shaded = <span className="font-bold">{filled}%</span>
      </div>
      {caption && <div className="text-sm text-ink/70">{caption}</div>}
    </div>
  );
}
